import { Phone } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import logo from "@/shared/assets/logo.svg";
import { LanguageSwitcher, SearchEntry } from "@/shared/ui";

/**
 * The home header on phones (D3–D5): a 52 px logo row (logo · UZ | RU · phone) that scrolls away, and a 56 px
 * search row that stays pinned. 108 px in total instead of the old three-row header.
 */
export function MobileHomeHeader() {
  const { t } = useTranslation(["shop", "common"]);
  return (
    <>
      <div className="bg-surface pt-safe lg:hidden">
        <div className="container-page flex h-13 items-center gap-2">
          <Link to="/" className="mr-auto" aria-label={t("common:brand")}>
            <img src={logo} width={112} height={19} alt="" />
          </Link>
          <LanguageSwitcher />
          <a
            href="tel:+998735152222"
            aria-label={t("shop:callUs")}
            className="flex size-11 items-center justify-center rounded-full text-ink-strong active:bg-canvas"
          >
            <Phone className="size-5" aria-hidden />
          </a>
        </div>
      </div>
      <div className="sticky top-0 z-30 bg-surface pb-2 shadow-[0_1px_0_0_var(--color-line)] lg:hidden">
        <div className="container-page pt-1.5">
          <SearchEntry />
        </div>
      </div>
    </>
  );
}
